{
  "title": "События",
  "subtitle_one": "{{count}} последняя смена состояния",
  "subtitle_few": "{{count}} последние смены состояния",
  "subtitle_many": "{{count}} последних смен состояния",
  "subtitle_other": "{{count}} последних смен состояния",
  "noSitesHint": "События появляются, когда мониторы площадки меняют состояние. Начните с создания площадки и агента.",
  "loadFailed": "Не удалось загрузить события",
  "loadFailedHint": "{{reason}} Проверьте связь с сервером.",
  "emptyTitle": "Событий пока нет",
  "emptyHint": "Это хорошая новость: ни один монитор площадки не менял состояние. Записи появятся, когда узел перестанет отвечать или вернётся в норму.",
  "column": {
    "at": "Время",
    "node": "Узел",
    "monitor": "Проверка",
    "transition": "Переход",
    "reason": "Причина"
  }
}
